export default "__VITE_ASSET__C40HeXr1__"